import { render, staticRenderFns } from "./TopInputLabel.vue?vue&type=template&id=facf4f74&"
import script from "./TopInputLabel.vue?vue&type=script&lang=js&"
export * from "./TopInputLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports